<template>

  <div class="py-4 container-fluid">
    <div class="row">

      <div class="col-md-8">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Crear quema en Horno</p>
              <argon-button color="success" size="sm" class="ms-auto" v-if="form.status < 2"
                @click="save">Guardar</argon-button>
            </div>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-sm">Información</p>
            <div class="row">
              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Consecutivo Horno</label>
                <argon-input type="text" v-model="form.consecutive" />
              </div>
              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Consecutivo secado</label>
                <argon-input type="text" v-model="form.consecutivo_secado" />
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="amount" class="form-label">Horno</label>
                  <select ref="modelSelect" id="models" class="form-select select2" style="width:100%;">
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Numero de quema</label>
                <argon-input type="number" v-model="form.burn_number" />
              </div>

              <!--  
              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Descripción</label>
                <ArgonTextarea type="text" v-model="form.description" />
              </div>
              -->
              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Fecha de inicio</label>
                <argon-input type="date" v-model="form.started_at" />
              </div>
              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Fecha estimada de entrega</label>
                <argon-input type="date" v-model="form.estimated_at" />
              </div>

              <div class="col-md-6" v-if="form.id != 0">
                <label for="example-text-input" class="form-control-label">Estado</label>
                <select name="" id="" class="form-select" v-model="form.status" @change="handleStatusChange" :disabled="form.status == 2">
                  <option value="0" v-if="form.status<1">Pendiente</option>
                  <option value="1">Activo</option>
                  <option value="2">Terminado</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4" v-show="form.id != 0">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Quemas en Horno</p>
              <argon-button color="warning" size="sm" class="ms-auto" v-if="form.status < 2"
                @click="openModalFurnace()">agregar</argon-button>
            </div>
          </div>
          <div class="card-body" style="max-height: 350px;overflow-y: auto;">
            <div class="d-flex flex-column gap-2">
              <div v-for="furnace in furnaces" :key="furnace.id" class="card border position-relative p-3"
                style="box-shadow: 0 1px 3px rgba(0,0,0,0.1);">

                <!-- Botón eliminar -->
                <a @click="deleteFurnace(furnace.id)" class="position-absolute top-0 end-0 m-2 text-danger"
                  style="cursor: pointer; font-size: 0.75rem; z-index: 10;">
                  <i class="fa fa-trash"></i>
                </a>

                <!-- Información principal -->
                <div class="pe-3">
                  <!-- Primera línea: Patio + Absorción -->
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <div class="d-flex align-items-center">
                      <i class="fa fa-fire text-warning me-1" style="font-size: 0.75rem;"></i>
                      <span class="fw-semibold" style="font-size: 0.85rem;">{{ furnace.patio_carbon }}</span>
                    </div>
                    <div class="d-flex align-items-center">
                      <i class="fa fa-tint text-info me-1" style="font-size: 0.75rem;"></i>
                      <span class="fw-medium" style="font-size: 0.75rem;">{{ furnace.water_absorption }}%</span>
                    </div>
                    <div class="d-flex align-items-center">
                      <i class="fa fa-tint text-info me-1" style="font-size: 0.75rem;"></i>
                      <span class="fw-medium" style="font-size: 0.75rem;">{{ furnace.water_absorption_2 }}%</span>
                    </div>
                  </div>

                  <!-- Segunda línea: Cantidad + Última modificación -->
                  <div class="d-flex justify-content-between align-items-center mb-1" style="font-size: 0.75rem;">
                    <span class="text-muted">
                      Cantidad Ton: <span class="text-dark fw-medium">{{ furnace.carbon_quantity }}</span>
                    </span>
                    <span class="text-muted">
                      {{ isValidDate(furnace.updated_at) ? new Date(furnace.updated_at).toLocaleDateString('es-ES') :
                      'Sin asignar' }}
                    </span>
                  </div>

                  <!-- Tercera línea: Fechas y horas -->
                  <div class="d-flex justify-content-between align-items-center" style="font-size: 0.75rem;">
                    <div class="d-flex align-items-center">
                      <i class="fa fa-calendar text-success me-1" style="font-size: 0.65rem;"></i>
                      <span>{{ furnace.start_date }}</span>
                      <i class="fa fa-clock text-success ms-2 me-1" style="font-size: 0.65rem;"></i>
                      <span>{{ furnace.start_time }}</span>
                    </div>
                    <div class="d-flex align-items-center">
                      <i class="fa fa-calendar text-danger me-1" style="font-size: 0.65rem;"></i>
                      <span>{{ furnace.end_date }}</span>
                      <i class="fa fa-clock text-danger ms-2 me-1" style="font-size: 0.65rem;"></i>
                      <span>{{ furnace.end_time }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Estado vacío -->
            <div v-if="furnaces.length === 0" class="text-center py-3 text-muted">
              <i class="fa fa-fire fa-2x mb-2 text-muted opacity-50"></i>
              <p class="mb-0" style="font-size: 0.85rem;">No hay quemas registradas</p>
            </div>
          </div>
        </div>
      </div>



      <div class="col-md-12" v-show="form.id != 0">

        <!-- Item 3 -->
        <div class="card mt-2">
          <div class="card-header d-flex justify-content-between align-items-center">
            CARGUE HORNO
            <button class="btn btn-primary btn-sm m-0" @click="toggleCollapse(2)">
              <i class="fa fa-chevron-down" aria-hidden="true"></i>
            </button>
          </div>
          <div class="collapse" ref="collapse2">
            <div class="card-body">


              <div class="mb-2">

                <div class="row">

                  <div class="table-responsive p-0">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" v-if="form.status < 1">
                            Opciones
                          </th>
                          <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Modulo</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Cantidad
                          </th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Averia cargue</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Averia secado</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Cantidad total</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Ultima modificación</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="value in loadings" :key="value.id">

                          <td class="align-middle text-center" v-if="form.status < 1">
                            <a @click="deleteLoadings(value.id)"
                              class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                              data-toggle="tooltip" data-original-title="Eliminar registro">
                              <i class="fa fa-trash"></i>
                            </a>
                          </td>

                          <td>
                            <div class="d-flex px-2 py-1">
                              <div class="d-flex flex-column justify-content-center">
                                <h6 class="mb-0 text-sm">{{ value?.driying?.production?.model?.name }}</h6>
                                <p class="text-xs text-secondary mb-0">Bodega: {{ value?.modulo?.bodega?.name }}</p>
                              </div>
                            </div>
                          </td>
                          <td class="align-middle text-center">
                            <div class="text-secondary text-xs font-weight-bold">
                              {{ value?.quantity }}
                            </div>
                          </td>
                          <td class="align-middle text-center">
                            <div class="text-secondary text-xs font-weight-bold">
                              {{ value?.averia_cargue }}
                            </div>
                          </td>
                          <td class="align-middle text-center">
                            <div class="text-secondary text-xs font-weight-bold">
                              {{ value?.averia_secado }}
                            </div>
                          </td>
                          <td class="align-middle text-center">
                            <div class="text-secondary text-xs font-weight-bold">
                              {{ value?.total_quantity }}
                            </div>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">
                              {{ isValidDate(value.updated_at) ? new
                                Date(value.updated_at).toLocaleDateString('es-ES') :
                                'Sin asignar' }}
                            </span>
                          </td>




                        </tr>


                      </tbody>
                    </table>
                  </div>
                </div>
              </div>



              <div class="mb-2" v-if="form.id != 0">
                <div class="pb-0">
                  <p class="text-uppercase mb-0">Usuarios asignados</p>

                </div>

                <div class="row">

                  <div class="table-responsive p-0">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Opciones</th>
                          <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Usuario
                          </th>
                          <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cuadrilla
                          </th>
                          <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Oficio
                          </th>
                          <!-- <th
                              class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Cant.
                              recibida</th>
                            <th
                              class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Cant.
                              entregada</th>
                            <th
                              class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Cant.
                              defectuosa</th> -->
                          <!--  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Fecha de asignación</th>
                            <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Fecha estimada entrega</th> -->
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Fecha Inicio</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Fecha Termino</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Fecha validado</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            observación</th>
                          <!--  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Total
                              ganancia</th> -->

                        </tr>
                      </thead>
                      <tbody v-if="data && data.data">
                        <tr v-for="value in data.data.filter(v => v.modulo === 3)" :key="value.id">
                          <td class="align-middle text-center">
                            <div
                              style="display: flex;justify-content: center; align-items: center;gap: 10px;height: 100%;">
                              <a @click="checkReceived(value)"
                                class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                                data-original-title="Registro" v-if="value.received_date == null">
                                <i class="fa fa-arrow-down"></i>
                              </a>


                              <a @click="checkDelivered(value)"
                                class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                                data-original-title="Eliminar registro"
                                v-if="(value.received_date != null && value.delivered_date == null) || (value.received_date != null && value.delivered_quantity < value.received_quantity)">
                                <i class="fa fa-arrow-up"></i>
                              </a>

                              <a @click="checkValidated(value)"
                                class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                                data-original-title="Eliminar registro"
                                v-if="value.delivered_date != null && value.validated_date == null && value.delivered_quantity >= value.received_quantity">
                                <i class="fa fa-check"></i>
                              </a>

                              <span style="color: forestgreen;" v-if="value.validated_date != null">
                                <i class="fa fa-check"></i>
                              </span>



                              <a @click="deleteUserRegister(value.id)"
                                class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                                data-original-title="Eliminar registro" v-if="value.received_date == null">
                                <i class="fa fa-trash"></i>
                              </a>
                            </div>
                          </td>
                          <td>
                            <div class="d-flex px-2 py-1">
                              <div class="d-flex flex-column justify-content-center">
                                <h6 class="mb-0 text-sm">{{ value.user.name }}</h6>
                              </div>
                            </div>
                          </td>
                          <td class="align-middle">
                            <div class="text-secondary text-xs font-weight-bold text-center">
                              {{ value?.cuadrilla }}
                            </div>
                          </td>
                          <td class="align-middle">
                            <div class="text-secondary text-xs font-weight-bold text-center">
                              {{ value?.oficio?.name }}
                            </div>
                          </td>
                          <!-- <td class="align-middle text-center">
                              {{ value.received_quantity }}
                            </td>
                            <td class="align-middle text-center">
                              {{ value.delivered_quantity }}
                            </td>
                            <td class="align-middle text-center">
                              {{ value.rejected_quantity }}
                            </td> -->
                          <!-- <td class="align-middle text-center">
                              <span class="text-secondary text-xs font-weight-bold">
                                {{ isValidDate(value.assigned_at) ? new
                                  Date(value.assigned_at).toLocaleDateString('es-ES') :
                                  'Sin asignar' }}
                              </span>
                            </td>
                            <td class="align-middle text-center">
                              <span class="text-secondary text-xs font-weight-bold">
                                {{ isValidDate(value.estimated_at) ? new
                                  Date(value.estimated_at).toLocaleDateString('es-ES') :
                                  'Sin asignar' }}
                              </span>
                            </td> -->
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">
                              {{ isValidDate(value.received_date) ? new
                                Date(value.received_date).toLocaleString('es-ES', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: true
                                }) : 'Sin asignar' }}
                            </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">
                              {{ isValidDate(value.delivered_date) ? new
                                Date(value.delivered_date).toLocaleString('es-ES', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: true
                                }) : 'Sin asignar' }}
                            </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">
                              {{ isValidDate(value.validated_date) ? new
                                Date(value.validated_date).toLocaleString('es-ES', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: true
                                }) : 'Sin asignar' }}
                            </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">
                              <a @click="viewObservation(value.observation)"
                                class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                                data-original-title="Registro">
                                <i class="fa fa-comment"></i>
                              </a>
                            </span>
                          </td>
                          <!-- <td class="align-middle text-center">
                              <span class="text-secondary text-xs font-weight-bold">
                                {{ parseFloat(value.total).toLocaleString('es-ES', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                }) }}
                              </span>
                            </td> -->


                        </tr>


                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="text-end" v-if="form.status < 2">
                <argon-button color="warning" size="sm" style="margin-right: 10px;" @click="openModal(3)">Asignar usuarios</argon-button>
                <argon-button color="success" size="sm" style="margin-right: 10px;" @click="openModalLoading()" v-if="form.status==0">Agregar cargue</argon-button>
              </div>

            </div>
          </div>
        </div>

        <!-- Item 4 -->
        <div class="card mt-2">
          <div class="card-header d-flex justify-content-between align-items-center">
            DESCARGUE
            <button class="btn btn-primary btn-sm m-0" @click="toggleCollapse(3)">
              <i class="fa fa-chevron-down" aria-hidden="true"></i>
            </button>
          </div>
          <div class="collapse" ref="collapse3">
            <div class="card-body">


              <div class="mb-2">

                <div class="row">

                  <div class="table-responsive p-0">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" v-if="form.status < 2">
                            Opciones
                          </th>
                          <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Modulo Cargue</th>
                          <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Primera</th>
                          <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Segunda
                          </th>
                          <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Tercera
                          </th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Averia descargue</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Averia crudo</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Cantidad total</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Ultima modificación</th>

                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="value in unloadings" :key="value.id" >

                          <td class="align-middle text-center" v-if="form.status < 2">
                          
                            <a @click="checkDeliveredDrying(value)"
                              class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                              data-original-title="Eliminar registro" v-if="value.delivered_at == null">
                              <i class="fa fa-check"></i>
                            </a>

                            <span style="color: forestgreen;" v-if="value.delivered_at != null">
                              <i class="fa fa-check"></i>
                            </span>
                            
                            <a @click="deleteUnloadings(value.id)"
                              class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                              data-toggle="tooltip" data-original-title="Eliminar registro"
                              v-if="value.delivered_at==null">
                              <i class="fa fa-trash"></i>
                            </a>
                          </td>

                          <td>
                            <div class="d-flex px-2 py-1">
                              <div class="d-flex flex-column justify-content-center">
                                <h6 class="mb-0 text-sm">{{ value?.inventory?.name || "" }}
                                </h6>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="d-flex px-2 py-1">
                              <div class="d-flex flex-column justify-content-center">
                                <h6 class="mb-0 text-sm">{{ value?.primera }}</h6>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="d-flex px-2 py-1">
                              <div class="d-flex flex-column justify-content-center">
                                <h6 class="mb-0 text-sm">{{ value?.segunda }}</h6>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="d-flex px-2 py-1">
                              <div class="d-flex flex-column justify-content-center">
                                <h6 class="mb-0 text-sm">{{ value?.tercera }}</h6>
                              </div>
                            </div>
                          </td>
                          <td class="align-middle text-center">
                            <div class="text-secondary text-xs font-weight-bold">
                              {{ value?.averia_descargue }}
                            </div>
                          </td>
                          <td class="align-middle text-center">
                            <div class="text-secondary text-xs font-weight-bold">
                              {{ value?.averia_crudo }}
                            </div>
                          </td>
                          <td class="align-middle text-center">
                            <div class="text-secondary text-xs font-weight-bold">
                              {{ value?.total_quantity }}
                            </div>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">
                              {{ isValidDate(value.updated_at) ? new
                                Date(value.updated_at).toLocaleDateString('es-ES') :
                                'Sin asignar' }}
                            </span>
                          </td>




                        </tr>


                      </tbody>
                    </table>
                  </div>
                </div>
              </div>



              <div class="mb-2" v-if="form.id != 0">
                <div class="pb-0">
                  <p class="text-uppercase mb-0">Usuarios asignados</p>

                </div>

                <div class="row">

                  <div class="table-responsive p-0">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Opciones</th>
                          <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Usuario
                          </th>
                          <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cuadrilla
                          </th>
                          <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Oficio
                          </th>
                          <!-- <th
                              class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Cant.
                              recibida</th>
                            <th
                              class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Cant.
                              entregada</th>
                            <th
                              class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Cant.
                              defectuosa</th> -->
                          <!-- <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Fecha de asignación</th>
                            <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Fecha estimada entrega</th> -->
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Fecha Inicio</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Fecha Termino</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Fecha validado</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            observación</th>
                          <!--  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                              Total
                              ganancia</th> -->

                        </tr>
                      </thead>
                      <tbody v-if="data && data.data">
                        <tr v-for="value in data.data.filter(v => v.modulo === 4)" :key="value.id">
                          <td class="align-middle text-center">
                            <div
                              style="display: flex;justify-content: center; align-items: center;gap: 10px;height: 100%;">
                              <a @click="checkReceived(value)"
                                class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                                data-original-title="Registro" v-if="value.received_date == null">
                                <i class="fa fa-arrow-down"></i>
                              </a>


                              <a @click="checkDelivered(value)"
                                class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                                data-original-title="Eliminar registro"
                                v-if="(value.received_date != null && value.delivered_date == null) || (value.received_date != null && value.delivered_quantity < value.received_quantity)">
                                <i class="fa fa-arrow-up"></i>
                              </a>

                              <a @click="checkValidated(value)"
                                class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                                data-original-title="Eliminar registro"
                                v-if="value.delivered_date != null && value.validated_date == null && value.delivered_quantity >= value.received_quantity">
                                <i class="fa fa-check"></i>
                              </a>

                              <span style="color: forestgreen;" v-if="value.validated_date != null">
                                <i class="fa fa-check"></i>
                              </span>



                              <a @click="deleteUserRegister(value.id)"
                                class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                                data-original-title="Eliminar registro" v-if="value.received_date == null">
                                <i class="fa fa-trash"></i>
                              </a>
                            </div>
                          </td>
                          <td>
                            <div class="d-flex px-2 py-1">
                              <div class="d-flex flex-column justify-content-center">
                                <h6 class="mb-0 text-sm">{{ value.user.name }}</h6>
                              </div>
                            </div>
                          </td>
                          <td class="align-middle">
                            <div class="text-secondary text-xs font-weight-bold text-center">
                              {{ value?.cuadrilla }}
                            </div>
                          </td>
                          <td class="align-middle">
                            <div class="text-secondary text-xs font-weight-bold text-center">
                              {{ value?.oficio?.name }}
                            </div>
                          </td>
                          <!-- <td class="align-middle text-center">
                              {{ value.received_quantity }}
                            </td>
                            <td class="align-middle text-center">
                              {{ value.delivered_quantity }}
                            </td>
                            <td class="align-middle text-center">
                              {{ value.rejected_quantity }}
                            </td> -->
                          <!-- <td class="align-middle text-center">
                              <span class="text-secondary text-xs font-weight-bold">
                                {{ isValidDate(value.assigned_at) ? new
                                  Date(value.assigned_at).toLocaleDateString('es-ES') :
                                  'Sin asignar' }}
                              </span>
                            </td>
                            <td class="align-middle text-center">
                              <span class="text-secondary text-xs font-weight-bold">
                                {{ isValidDate(value.estimated_at) ? new
                                  Date(value.estimated_at).toLocaleDateString('es-ES') :
                                  'Sin asignar' }}
                              </span>
                            </td> -->
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">
                              {{ isValidDate(value.received_date) ? new
                                Date(value.received_date).toLocaleString('es-ES', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: true
                                }) : 'Sin asignar' }}
                            </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">
                              {{ isValidDate(value.delivered_date) ? new
                                Date(value.delivered_date).toLocaleString('es-ES', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: true
                                }) : 'Sin asignar' }}
                            </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">
                              {{ isValidDate(value.validated_date) ? new
                                Date(value.validated_date).toLocaleString('es-ES', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: true
                                }) : 'Sin asignar' }}
                            </span>
                          </td>
                          <td class="align-middle text-center">
                            <span class="text-secondary text-xs font-weight-bold">
                              <a @click="viewObservation(value.observation)"
                                class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                                data-original-title="Registro">
                                <i class="fa fa-comment"></i>
                              </a>
                            </span>
                          </td>
                          <!-- <td class="align-middle text-center">
                              <span class="text-secondary text-xs font-weight-bold">
                                {{ parseFloat(value.total).toLocaleString('es-ES', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                }) }}
                              </span>
                            </td> -->


                        </tr>


                      </tbody>
                    </table>
                  </div>
                </div>
              </div>


              <div class="text-end" v-if="form.status < 2">
                <argon-button color="warning" size="sm" style="margin-right: 10px;" @click="openModal(4)">Asignar
                  usuarios</argon-button>
                <argon-button color="success" size="sm" style="margin-right: 10px;"
                  @click="openModalUnloading()">Agregar descargue</argon-button>
              </div>

            </div>
          </div>
        </div>

      </div>


    </div>





    <!-- Modal Asignar tecnico -->
    <div class="modal fade" id="ModalUsers" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog  modal-lg">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Asignar Usuarios</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form class="row">

              <div class="col-6 mb-3">
                <label for="example-text-input" class="form-control-label">Cuadrilla</label>

                <select ref="cuadrillaSelect" id="cuadrilla" class="form-select select2" style="width:100%;">
                  <option value="">
                    Seleccionar cuadrilla
                  </option>
                  <option v-for="process in cuadrillas" :key="process.id" :value="process.id">
                    {{ process.name }}
                  </option>
                </select>
              </div>

              <div class="col-6 mb-3">
                <label for="amount" class="form-label">Filtrar por oficios</label>
                <select ref="processesSelect" id="oficio" class="form-select select2" style="width:100%;">
                </select>
              </div>

              <div class="col-12 mb-3" v-if="filteredUsers.length > 0">
                <label for="users-checkbox-list" class="form-label">Usuarios</label>
                <div id="users-checkbox-list" class="checkbox-grid">
                  <div v-for="user in filteredUsers" :key="user.id">
                    <argon-checkbox :id="'user-' + user.id" :value="user.id" v-model="production_user.user_id"
                      :checked="production_user.user_id.includes(user.id)">
                      {{ user.name }} - (Cuadrilla: {{ user.cuadrilla_name ?? "Sin asignar" }})
                    </argon-checkbox>

                  </div>
                </div>
              </div>

              <!--        <div class="col-6 mb-3">
                <label for="example-text-input" class="form-control-label">Fecha de asignación</label>
                <argon-input type="date" v-model="production_user.assigned_at" />
              </div>

              <div class="col-6 mb-3">
                <label for="example-text-input" class="form-control-label">Fecha estimada de entrega</label>
                <argon-input type="date" v-model="production_user.estimated_at" />
              </div>
 -->
            </form>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitForm">Guardar</button>
          </div>
        </div>
      </div>
    </div>



    <!-- Modal cargue  -->
    <div class="modal fade" id="ModalLoading" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog  modal-lg">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Agregar registro de cargue</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="bodega_id_cargue" class="form-label">Modulo</label>
                  <select id="bodega_id_cargue" ref="moduloSelect" class="form-select" style="width: 100%;">
                    <option value="">Seleccionar material producción</option>
                  </select>
                </div>
              </div>

              <div class="col-md-4" v-show="selectedModel?.production?.model">
                <div class="mb-3">
                  <label for="cantidad_cargue" class="form-control-label">Cantidad</label>
                  <input type="number" class="form-control" id="cantidad_cargue" v-model="loading.quantity">
                </div>
              </div>
              <div class="col-md-4" v-show="selectedModel?.production?.model?.averia_cargue != '' && selectedModel?.production?.model?.averia_cargue != null">
                <div class="mb-3">
                  <label for="cantidad_averia_cargue" class="form-control-label">Averia en cargue</label>
                  <input type="number" class="form-control" id="cantidad_averia_cargue"
                    v-model="loading.averia_cargue">
                </div>
              </div>
              <div class="col-md-4" v-show="selectedModel?.production?.model?.averia_secado != '' && selectedModel?.production?.model?.averia_secado != null">
                <div class="mb-3">
                  <label for="cantidad_averia_cargue" class="form-control-label">Averia en secado</label>
                  <input type="number" class="form-control" id="cantidad_averia_cargue"
                    v-model="loading.averia_secado">
                </div>
              </div>
              <div class="col-md-4" v-show="selectedModel?.production?.model">
                <div class="mb-3">
                  <label for="cantidad_total_cargue" class="form-control-label">Cantidad Total</label>
                  <input type="number" class="form-control" id="cantidad_total_cargue" v-model="loading.total_quantity"
                    readonly>
                </div>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalLoading">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="saveLoading">Guardar</button>
          </div>
        </div>
      </div>
    </div>



    <!-- Modal cargue  -->
    <div class="modal fade" id="ModalUnloading" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog  modal-lg">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Agregar registro de descargue</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">

              <div class="col-md-12">
                <div class="mb-3">
                  <label for="bodega_id_cargue" class="form-label">Material de cargue</label>
                  <select ref="selectUnloadingWarehouse" class="form-select" style="width:100%;">
                  </select>
                </div>
              </div>

              <div class="col-md-4" v-show="selectedModel.primera != '' && selectedModel.primera != null">
                <div class="mb-3">
                  <label for="cantidad_cargue" class="form-control-label">Primera</label>
                  <input type="number" class="form-control" id="primera" v-model="unloading.primera">
                </div>
                 <div class="mb-3">
                  <label for="modulo_primera" class="form-label select2">Modulo primera</label>
                  <select ref="moduloPrimera" id="modulo_primera" class="form-select" style="width: 100%;">
                  </select>
                </div>
              </div>

              <div class="col-md-4" v-show="selectedModel.segunda != '' && selectedModel.segunda != null">
                <div class="mb-3">
                  <label for="cantidad_cargue" class="form-control-label">Segunda</label>
                  <input type="number" class="form-control" id="segunda" v-model="unloading.segunda">
                </div>
                 <div class="mb-3">
                  <label for="modulo_segunda" class="form-label select2">Modulo segunda</label>
                  <select ref="moduloSegunda" id="modulo_segunda" class="form-select" style="width: 100%;">
                  </select>
                </div>
              </div>

              <div class="col-md-4" v-show="selectedModel.tercera != '' && selectedModel.tercera != null">
                <div class="mb-3">
                  <label for="cantidad_cargue" class="form-control-label">Tercera</label>
                  <input type="number" class="form-control" id="tercera" v-model="unloading.tercera">
                </div>
                <div class="mb-3">
                  <label for="modulo_tercera" class="form-label select2">Modulo tercera</label>
                  <select ref="moduloTercera" id="modulo_tercera" class="form-select" style="width: 100%;">
                  </select>
                </div>
              </div>
             

              <div class="col-md-4" v-show="selectedModel.averia_descargue != '' && selectedModel.averia_descargue != null">
                <div class="mb-3">
                  <label for="cantidad_averia_cargue" class="form-control-label">Averia en descargue</label>
                  <input type="number" class="form-control" id="cantidad_averia_cargue"
                    v-model="unloading.averia_descargue">
                </div>
              </div>

              <div class="col-md-4" v-show="selectedModel.averia_crudo != '' && selectedModel.averia_crudo != null">
                <div class="mb-3">
                  <label for="cantidad_averia_cargue" class="form-control-label">Averia en crudo</label>
                  <input type="number" class="form-control" id="cantidad_averia_cargue"
                    v-model="unloading.averia_crudo">
                </div>
              </div>

              <div class="col-md-4" v-show="selectedModel && selectedModel.id && selectedModel.id != 0">
                <div class="mb-3">
                  <label for="cantidad_total_cargue" class="form-control-label">Cantidad Total</label>
                  <input type="number" class="form-control" id="cantidad_total_cargue"
                    v-model="unloading.total_quantity" readonly>
                </div>
              </div>

            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalUnloading">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="saveUnloading">Guardar</button>
          </div>
        </div>
      </div>
    </div>




    <div class="modal fade" id="ModalFurnaceBurn" tabindex="-1" aria-labelledby="furnaceBurnModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="furnaceBurnModalLabel">Agregar registro de quema</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div class="row">
              <!-- Patio Carbón -->
              <div class="col-md-12 mb-3">
                <label for="patio_carbon" class="form-label">Patio Carbón</label>
                <select id="patio_carbon" class="form-select" v-model="furnaceBurn.patio_carbon">
                  <option value="">Seleccionar las opciones</option>
                  <option value="patio1">Patio 1</option>
                  <option value="patio2">Patio 2</option>
                  <option value="patio3">Patio 3</option>
                </select>
              </div>

              <!-- Cantidad de Carbón y Absorción de Agua -->
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="carbon_quantity" class="form-label">Cantidad Toneladas de Carbón</label>
                  <div class="input-group">
                    <input type="text" class="form-control" id="carbon_quantity" v-model="furnaceBurn.carbon_quantity"
                      placeholder="Se digita la cantidad MANUALMENTE">
                    <span class="input-group-text">TON</span>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="mb-3">
                  <label for="water_absorption" class="form-label">Absorción de Agua P1</label>
                  <div class="input-group">
                    <input type="text" class="form-control" id="water_absorption" v-model="furnaceBurn.water_absorption"
                      placeholder="Se digita la cantidad MANUALMENTE">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="mb-3">
                  <label for="water_absorption" class="form-label">Absorción de Agua P2</label>
                  <div class="input-group">
                    <input type="text" class="form-control" id="water_absorption" v-model="furnaceBurn.water_absorption_2"
                      placeholder="Se digita la cantidad MANUALMENTE">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>

              <!-- Sección Tiempo de Quema -->
              <div class="col-12 mb-4">
                <div class="card" style="background-color: #fff3cd; border: 1px solid #ffeaa7;">
                  <div class="card-body">
                    <div class="d-flex align-items-center mb-3">
                      <span class="badge bg-warning text-dark me-3 fs-6">TIEMPO DE QUEMA</span>
                      <span class="badge bg-warning fs-6">{{ burnTime }} HORAS</span>
                    </div>
                    <p class="text-muted small mb-3">Se calcula el tiempo y se ve reflejado aquí</p>

                    <div class="row">
                      <!-- Hora y Fecha de Inicio -->
                      <div class="col-md-3">
                        <label class="form-label bg-light px-2 py-1 rounded small">HORA INICIO</label>
                        <input type="time" class="form-control" v-model="furnaceBurn.start_time"
                          @change="calculateBurnTime">
                      </div>

                      <div class="col-md-3">
                        <label class="form-label bg-light px-2 py-1 rounded small">FECHA INICIO</label>
                        <input type="date" class="form-control" v-model="furnaceBurn.start_date"
                          @change="calculateBurnTime">
                      </div>

                      <!-- Hora y Fecha Final -->
                      <div class="col-md-3">
                        <label class="form-label bg-light px-2 py-1 rounded small">HORA FINAL</label>
                        <input type="time" class="form-control" v-model="furnaceBurn.end_time"
                          @change="calculateBurnTime">
                      </div>

                      <div class="col-md-3">
                        <label class="form-label bg-light px-2 py-1 rounded small">FECHA FINAL</label>
                        <input type="date" class="form-control" v-model="furnaceBurn.end_date"
                          @change="calculateBurnTime">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalFurnaceBurn">Cerrar</button>
            <button type="button" class="btn btn-warning" @click="saveFurnaceBurn">Guardar</button>
          </div>
        </div>
      </div>
    </div>




  </div>

</template>



<script>

import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import ArgonCheckbox from "../../../components/ArgonCheckbox.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';
import { Modal } from 'bootstrap';
//import * as bootstrap from 'bootstrap';
import { Collapse } from 'bootstrap';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "Models Create",
  setup() {
    const route = useRoute();
    return { route };
  },
  data() {
    return {
      furnaceBurn: {
        id: 0,
        production_oven_id: 0,
        patio_carbon: '',
        carbon_quantity: '',
        water_absorption: '',
        water_absorption_2: '',
        start_time: '',
        start_date: '',
        end_time: '',
        end_date: ''
      },
      furnaces: [],
      burnTime: 0,
      bsCollapse: [null, null, null, null],
      showMenu: false,
      ModalUsers: null,
      ModalDrying: null,
      ModalLoading: null,
      ModalUnloading: null,
      modalNovelty: null,
      modalDefects: null,
      modalModel: null,
      oficio_id: null,
      processes: [],
      cuadrillas: [],
      form: {
        id: 0,
        consecutive: '',
        consecutivo_secado: '',
        user_id: '',
        oven_id: 0,
        burn_number: 1,
        description: '',
        status: 0,
        started_at: '',
        estimated_at: '',
        finished_at: '',
        finished_user_id: '',
        created_at: '',
        updated_at: '',
      },
      extrusion: {
        id: 0,
        production_id: 0,
        machine: '',
        setup_count: 0,
        nozzle_type: '',
        scheduled_time: 0,
        lost_time: 0,
        effective_time: 0,
        setup_number: 0,
        cut_count: 0,
        units_per_cut: 0,
        quantity: 0,
        extrusion_quantity: 0,
        extruded_weight: 0,
        dry_weight: 0,
        clay_consumption: 0,
        total_consumption: 0
      },
      drying: {
        id: 0,
        production_id: 0,
        oven_id: '',
        quantity: 0,
        damage_quantity: 0,
        averia_descargue: 0,
        averia_crudo: 0,
        warehouse_id: '',
        started_at: '',
        assigned_at: '',
        delivered_at: '',
        total_quantity: 0
      },
      loading: {
        id: 0,
        production_oven_id: 0,
        production_drying_id: 0,
        quantity: 0,
        burning_number: 0,
        averia_cargue: 0,
        averia_secado: 0,
        total_quantity: 0,
        warehouse_id: ''
      },
      unloading: {
        id: 0,
        production_oven_id:0,
        production_id: 0,
        inventory_id: 0,
        primera: 0,
        segunda: 0,
        tercera: 0,
        quantity: 0,
        averia_descargue: 0,
        averia_crudo: 0,
        total_quantity: 0,
        warehouse_id: '',
        details: [],
        warehouse_primera:'40',
        warehouse_segunda:'40',
        warehouse_tercera:'40',
      },
      dryings: [],
      loadings: [],
      unloadings: [],
      collapseInstances: {},
      size: {
        size: '',
        color_id: '',
        model_id: '',
        quantity: 0,
        status: 1
      },
      filteredUsers: [],
      bodegas: [],
      materials: [],
      models: [],
      insumos: [],
      insumosInventory: [],
      sizes: [],
      users: [],
      colors: [],
      purchases: [],
      selectedModel: {},
      purchase: {
        id: 0,
        inventory_id: 0,
        quantity: 0,
        price: 0,
        total_price: 0,
        supplier_name: ''
      },
      production_user: {
        id: 0,
        user_id: [],
        production_models_id: 0,
        oficio_id: 0,
        production_id: null,
        production_oven_id: null,
        modulo: 0,
        received_quantity: 0,
        delivered_quantity: 0,
        price: 0,
        assigned_at: '',
        estimated_at: '',
        cuadrilla: ''
      },
      production_model: {
        id: 0,
        production_id: 0,
        model_id: 0,
        size_id: 0,
        bodega_id: '',
        quantity_to_produce: 0,
        price: 0,
      },
      data: {},
      modal: {
        id: 0,
        user_id: null,
        project_id: null,
        amount: "",
        status: "active"
      },
      novelty: {
        id: 0,
        production_id: 0,
        total: 0,
        observation: ''
      },
      fieldPayment: false,
      modalEvidencia: [],
      novelties: [],
      maxDryingQuantity: 0
    };
  },
  components: { ArgonInput, ArgonButton, ArgonCheckbox },
  computed: {

    formattedTotalNovelty: {
      get() {
        // Formatea el precio a punto de mil y sin decimales
        return Math.floor(this.novelty.total).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        // Elimina los puntos y actualiza el precio sin decimales
        this.novelty.total = parseFloat(value.replace(/\./g, "") || 0);
      },
    },
    formattedTotalUser: {
      get() {
        // Formatea el precio a punto de mil y sin decimales
        return Math.floor(this.production_user.price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        // Elimina los puntos y actualiza el precio sin decimales
        this.production_user.price = parseFloat(value.replace(/\./g, "") || 0);
      },
    },
    totalPriceUser() {
      // Calcula el total y aplica el formateo
      const total = this.production_user.received_quantity * this.production_user.price;
      return total
        ? total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        : "0";
    },
    formattedPrice: {
      get() {
        return this.production_model.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        this.production_model.price = Math.floor(value.replace(/\./g, "") || 0);
      },
    },
    totalPrice() {
      // Calcula el total y aplica el formateo
      const total = this.production_model.quantity_to_produce * this.production_model.price;
      return total
        ? total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        : "0";
    },


  },
  watch: {
    'extrusion.scheduled_time': function () {
      this.calcularTiempoEfectivo();
    },
    'extrusion.lost_time': function () {
      this.calcularTiempoEfectivo();
    },
    'extrusion.cut_count': function () {
      this.calcularCantidad();
    },
    'extrusion.units_per_cut': function () {
      this.calcularCantidad();
    },
    'extrusion.extruded_weight': function () {
      this.extrusion.dry_weight = this.extrusion.extruded_weight * 0.845;
    },
    'extrusion.extrusion_quantity': function () {
      this.drying.quantity = this.extrusion.extrusion_quantity;
      this.calcularConsumo();
    },
    'extrusion.dry_weight': function () {
      this.calcularConsumo();
    },
    // Calcular totales automáticamente para el módulo de secado
    'drying.quantity': function () {
      if (this.drying.quantity > this.maxDryingQuantity) {
        this.drying.quantity = this.maxDryingQuantity;
      }
      this.calcularTotalCantidadSecado();
    },
    'drying.damage_quantity': function () {
      this.calcularTotalCantidadSecado();
    },
    'drying.averia_descargue': function () {
      this.calcularTotalCantidadSecado();
    },
    'drying.averia_crudo': function () {
      this.calcularTotalCantidadSecado();
    },

    // Calcular totales automáticamente para el módulo de cargue
    'loading.quantity': function () {

      const quantity = Number(this.loading.quantity ?? 0) + Number(this.loading.averia_cargue ?? 0) + Number(this.loading.averia_secado ?? 0);

      const rest = this.selectedModel.total_available-(quantity - this.loading.quantity);
      // Verificar si la cantidad acumulada excede el total permitido
      if (quantity > this.selectedModel.total_available) {
        // Ajustar unloading.primera para que no exceda el total
        this.loading.quantity = rest < 0 ? 0 : rest; // remplazar la cantidad por el valor restante
      }

      this.calcularTotalCantidadCargue();
    },
    'loading.averia_cargue': function () {

      const quantity = Number(this.loading.quantity ?? 0) + Number(this.loading.averia_cargue ?? 0) + Number(this.loading.averia_secado ?? 0);

      const rest = this.selectedModel.total_available-(quantity - this.loading.averia_cargue);
      // Verificar si la cantidad acumulada excede el total permitido
      if (quantity > this.selectedModel.total_available) {
        // Ajustar unloading.primera para que no exceda el total
        this.loading.averia_cargue = rest < 0 ? 0 : rest; // remplazar la cantidad por el valor restante
      }

      this.calcularTotalCantidadCargue();
    },
    'loading.averia_secado': function () {

      const quantity = Number(this.loading.quantity ?? 0) + Number(this.loading.averia_cargue ?? 0) + Number(this.loading.averia_secado ?? 0);

      const rest = this.selectedModel.total_available-(quantity - this.loading.averia_secado);
      // Verificar si la cantidad acumulada excede el total permitido
      if (quantity > this.selectedModel.total_available) {
        // Ajustar unloading.primera para que no exceda el total
        this.loading.averia_secado = rest < 0 ? 0 : rest; // remplazar la cantidad por el valor restante
      }

      this.calcularTotalCantidadCargue();

    },
    'unloading.primera': function () {
      const quantity = Number(this.unloading.primera ?? 0) + Number(this.unloading.segunda ?? 0) + Number(this.unloading.tercera ?? 0) + Number(this.unloading.averia_descargue ?? 0) + Number(this.unloading.averia_crudo ?? 0);

      const rest = this.selectedModel.total_quantity-(quantity - this.unloading.primera);
      // Verificar si la cantidad acumulada excede el total permitido
      if (quantity > this.selectedModel.total_quantity) {
        // Ajustar unloading.primera para que no exceda el total
        this.unloading.primera = rest < 0 ? 0 : rest; // remplazar la cantidad por el valor restante
      }
      this.calcularTotalCantidadDescargue();
    },
    'unloading.segunda': function () {
      const quantity = Number(this.unloading.primera ?? 0) + Number(this.unloading.segunda ?? 0) + Number(this.unloading.tercera ?? 0) + Number(this.unloading.averia_descargue ?? 0) + Number(this.unloading.averia_crudo ?? 0);

      const rest = this.selectedModel.total_quantity-(quantity - this.unloading.segunda);
      // Verificar si la cantidad acumulada excede el total permitido
      if (quantity > this.selectedModel.total_quantity) {
        // Ajustar unloading.primera para que no exceda el total
        this.unloading.segunda = rest < 0 ? 0 : rest; // remplazar la cantidad por el valor restante
      }
      this.calcularTotalCantidadDescargue();
    },
    'unloading.tercera': function () {
       const quantity = Number(this.unloading.primera ?? 0) + Number(this.unloading.segunda ?? 0) + Number(this.unloading.tercera ?? 0) + Number(this.unloading.averia_descargue ?? 0) + Number(this.unloading.averia_crudo ?? 0);

      const rest = this.selectedModel.total_quantity-(quantity - this.unloading.tercera);
      // Verificar si la cantidad acumulada excede el total permitido
      if (quantity > this.selectedModel.total_quantity) {
        // Ajustar unloading.primera para que no exceda el total
        this.unloading.tercera = rest < 0 ? 0 : rest; // remplazar la cantidad por el valor restante
      }
      this.calcularTotalCantidadDescargue();
    },
    'unloading.averia_descargue': function () {
      const quantity = Number(this.unloading.primera ?? 0) + Number(this.unloading.segunda ?? 0) + Number(this.unloading.tercera ?? 0) + Number(this.unloading.averia_descargue ?? 0) + Number(this.unloading.averia_crudo ?? 0);

      const rest = this.selectedModel.total_quantity-(quantity - this.unloading.averia_descargue);
      // Verificar si la cantidad acumulada excede el total permitido
      if (quantity > this.selectedModel.total_quantity) {
        // Ajustar unloading.primera para que no exceda el total
        this.unloading.averia_descargue = rest < 0 ? 0 : rest; // remplazar la cantidad por el valor restante
      }
      this.calcularTotalCantidadDescargue();
    },
    'unloading.averia_crudo': function () {
      const quantity = Number(this.unloading.primera ?? 0) + Number(this.unloading.segunda ?? 0) + Number(this.unloading.tercera ?? 0) + Number(this.unloading.averia_descargue ?? 0) + Number(this.unloading.averia_crudo ?? 0);

      const rest = this.selectedModel.total_quantity-(quantity - this.unloading.averia_crudo);
      // Verificar si la cantidad acumulada excede el total permitido
      if (quantity > this.selectedModel.total_quantity) {
        // Ajustar unloading.primera para que no exceda el total
        this.unloading.averia_crudo = rest < 0 ? 0 : rest; // remplazar la cantidad por el valor restante
      }
      this.calcularTotalCantidadDescargue();
    },


    'form.bodega_id': function () {
      this.handleBodegaChange();
    },

  },
  methods: {
    async getBodegas() {
      try {
        // Obtener las bodegas desde el store
        this.bodegas = await this.$store.dispatch('bodegas/getAll');

        // Obtener referencia al select
        const $selectModulo = $(this.$refs.moduloPrimera);

        // Destruir la instancia previa de Select2 si existe
        if ($selectModulo.data('select2')) {
          $selectModulo.select2('destroy');
        }

        // Limpiar y agregar las opciones dinámicamente
        $selectModulo.empty().append('<option value="">Seleccionar módulo</option>');

        this.bodegas.filter(h => parseInt(h.tipo) === 5).forEach(model => {
          const option = new Option(model.name, model.id);
          $(option).attr('data-artificial', model.artificial ? '1' : '0');
          $selectModulo.append(option);
        });

        // Inicializar Select2
        $selectModulo.select2({
          placeholder: 'Seleccione un módulo',
          allowClear: true, // Cambiado a true para permitir limpiar la selección
          dropdownParent: $('#ModalUnloading .modal-body')
        }).on('change', () => {
           this.unloading.warehouse_primera = $selectModulo.val();
        });

        // Si hay un valor pre-seleccionado en drying.warehouse_id
        if (this.unloading.warehouse_primera) {
          $selectModulo.val(this.unloading.warehouse_primera).trigger('change');
        }

        $selectModulo.val("40").trigger('change');
        this.unloading.warehouse_primera = "40";


        // Obtener referencia al select
        const $selectModuloSegunda = $(this.$refs.moduloSegunda);

        // Destruir la instancia previa de Select2 si existe
        if ($selectModuloSegunda.data('select2')) {
          $selectModuloSegunda.select2('destroy');
        }

        // Limpiar y agregar las opciones dinámicamente
        $selectModuloSegunda.empty().append('<option value="">Seleccionar módulo</option>');

        this.bodegas.filter(h => parseInt(h.tipo) === 5).forEach(model => {
          const option = new Option(model.name, model.id);
          $(option).attr('data-artificial', model.artificial ? '1' : '0');
          $selectModuloSegunda.append(option);
        });

        // Inicializar Select2
        $selectModuloSegunda.select2({
          placeholder: 'Seleccione un módulo',
          allowClear: true, // Cambiado a true para permitir limpiar la selección
          dropdownParent: $('#ModalUnloading .modal-body')
        }).on('change', () => {
           this.unloading.warehouse_segunda = $selectModuloSegunda.val();
        });

        // Si hay un valor pre-seleccionado en drying.warehouse_id
        if (this.unloading.warehouse_segunda) {
          $selectModuloSegunda.val(this.unloading.warehouse_segunda).trigger('change');
        }
        $selectModuloSegunda.val("40").trigger('change');
        this.unloading.warehouse_segunda = "40";

        // Obtener referencia al select
        const $selectModuloTercera = $(this.$refs.moduloTercera);

        // Destruir la instancia previa de Select2 si existe
        if ($selectModuloTercera.data('select2')) {
          $selectModuloTercera.select2('destroy');
        }

        // Limpiar y agregar las opciones dinámicamente
        $selectModuloTercera.empty().append('<option value="">Seleccionar módulo</option>');

        this.bodegas.filter(h => parseInt(h.tipo) === 5).forEach(model => {
          const option = new Option(model.name, model.id);
          $(option).attr('data-artificial', model.artificial ? '1' : '0');
          $selectModuloTercera.append(option);
        });

        // Inicializar Select2
        $selectModuloTercera.select2({
          placeholder: 'Seleccione un módulo',
          allowClear: true, // Cambiado a true para permitir limpiar la selección
          dropdownParent: $('#ModalUnloading .modal-body')
        }).on('change', () => {
           this.unloading.warehouse_tercera = $selectModuloTercera.val();
        });

        // Si hay un valor pre-seleccionado en drying.warehouse_id
        if (this.unloading.warehouse_tercera) {
          $selectModuloTercera.val(this.unloading.warehouse_tercera).trigger('change');
        }
        $selectModuloTercera.val("40").trigger('change');
        
        this.unloading.warehouse_tercera = "40";

        


      } catch (error) {
        console.error('Error al obtener bodegas:', error);
      }
    },
    calculateBurnTime() {
      // Calcular tiempo de quema si todas las fechas y horas están completas
      if (this.furnaceBurn.start_date && this.furnaceBurn.start_time &&
        this.furnaceBurn.end_date && this.furnaceBurn.end_time) {

        const startDateTime = new Date(`${this.furnaceBurn.start_date}T${this.furnaceBurn.start_time}`);
        const endDateTime = new Date(`${this.furnaceBurn.end_date}T${this.furnaceBurn.end_time}`);

        const diffInMs = endDateTime - startDateTime;
        const diffInHours = Math.round(diffInMs / (1000 * 60 * 60));

        if (diffInHours > 0) {
          this.burnTime = diffInHours;
        }
      }
    },

    async getFurnace() {
      this.furnaces = await this.$store.dispatch("productionOvenFurnace/getData", this.form.id);
      console.log(this.furnaces);
    },
    async saveFurnaceBurn() {
      // Validaciones básicas
      if (!this.furnaceBurn.patio_carbon) {
        alert('Por favor seleccione un patio de carbón');
        return;
      }

      if (!this.furnaceBurn.carbon_quantity) {
        alert('Por favor ingrese la cantidad de carbón');
        return;
      }

      if (!this.furnaceBurn.water_absorption) {
        alert('Por favor ingrese la absorción de agua');
        return;
      }



      // Aquí iría la lógica para guardar los datos
      console.log('Datos de quema a guardar:', {
        ...this.furnaceBurn,
        burn_time: this.burnTime
      });

      console.log("Guardar Extrusion");
      try {
        const response = await this.$store.dispatch("productionOvenFurnace/save", this.furnaceBurn);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then(() => {
            this.getFurnace();
            this.closeModalFurnaceBurn();
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        Swal.close();
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }


    },

    openModalFurnace() {
      const modalElement = document.getElementById('ModalFurnaceBurn');
      this.modalFurnace = new Modal(modalElement); // Guarda la instancia del modal
      this.modalFurnace.show(); // Muestra el modal
    },
    closeModalFurnaceBurn() {
      // Cerrar modal usando Bootstrap
      if (this.modalFurnace) {
        this.modalFurnace.hide(); // Cierra el modal
      }
      const oven_id = this.furnaceBurn.production_oven_id;

      // Resetear formulario
      this.furnaceBurn = {
        id: 0,
        production_oven_id:oven_id,
        patio_carbon: '',
        carbon_quantity: '',
        water_absorption: '',
        start_time: '',
        start_date: '',
        end_time: '',
        end_date: ''
      };
      this.burnTime = 20;
    },

    async deleteLoadings(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionLoading/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            this.getLoadings();
            this.getDrying();

            await Swal.fire(
              'Eliminado!',
              'El registro se ha sido eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el empleado');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },

    async deleteFurnace(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionOvenFurnace/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            this.getFurnace();

            await Swal.fire(
              'Eliminado!',
              'El registro se ha sido eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el empleado');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async deleteUnloadings(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionUnloading/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            this.getMaterials();
            this.getLoadings();
            this.getUnloadings();

            await Swal.fire(
              'Eliminado!',
              'El registro se ha sido eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el empleado');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },

    async checkDeliveredDrying(value) {

      try {
        const result = await Swal.fire({
          title: 'Marcar como entregado',
          text: 'Al realizar esta acción se registrará la fecha de entrega del descargue.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, aceptar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {

          const now = new Date();
          const pad = n => String(n).padStart(2, '0');

          value.delivered_at = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;

          const response = await this.$store.dispatch("productionUnloading/save", value);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Registro de descargue entregado!',
              'El registro se ha guardado correctamente.',
              'success'
            );

            this.getUnloadings();
          } else {
            throw new Error(response.data.message || 'Error al guardar el registro');
          }
        }
      } catch (error) {
        console.error("Error al guardar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    calculateTotalQuantity() {
      const total = this.dryings.reduce((total, item) => {
        return total + (Number(item.quantity) || 0);
      }, 0);

      this.drying.quantity = total - this.extrusion.extrusion_quantity;
      this.maxDryingQuantity = this.drying.quantity;
    },
    toggleCollapse(index) {
      // Cierra todos
      this.bsCollapse.forEach((instance, i) => {
        if (instance && i !== index) instance.hide()
      })
      // Alterna el seleccionado
      const selected = this.bsCollapse[index]
      if (selected) selected.toggle()
    },
    calcularTotalCantidadSecado() {
      this.drying.total_quantity =
        Number(this.drying.quantity) -
        Number(this.drying.damage_quantity) -
        Number(this.drying.averia_descargue) -
        Number(this.drying.averia_crudo);
    },
    calcularTotalCantidadCargue() {
      this.loading.total_quantity = Number(this.loading.quantity ?? 0) + Number(this.loading.averia_cargue ?? 0) + Number(this.loading.averia_secado ?? 0);
    },

    calcularTotalCantidadDescargue() {
      this.unloading.total_quantity = Number(this.unloading.primera ?? 0) + Number(this.unloading.segunda ?? 0) + Number(this.unloading.tercera ?? 0) + Number(this.unloading.averia_descargue ?? 0) + Number(this.unloading.averia_crudo ?? 0);
    },
    async saveExtruction() {
      console.log("Guardar Extrusion");
      try {
        const response = await this.$store.dispatch("productionExtrusion/save", this.extrusion);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then(() => {
            this.extrusion.id = response?.data?.id || 0;
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        Swal.close();
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }

    },


    async getDrying() {
      const dryingList = await this.$store.dispatch("productionDrying/getAll");

      // Filtrar solo los secados entregados y con disponibilidad
      this.dryings = dryingList.filter(h => h.delivered_at != null && h.total_available > 0);

      // Referencia al select
      const $selectModulo = $(this.$refs.moduloSelect);

      // Destruir select2 anterior si existe para evitar duplicados de eventos
      if ($selectModulo.hasClass("select2-hidden-accessible")) {
        $selectModulo.select2("destroy");
      }

      // Limpiar y agregar opción por defecto
      $selectModulo.empty().append('<option value="">Seleccionar modulo</option>');

      // Agregar opciones de los secados
      this.dryings.forEach(model => {
        $selectModulo.append(new Option(model?.production?.model?.name + ` - Módulo: ${model?.bodega?.name}` + ` - Cantidad: ${model?.total_available}`, model.id));
      });


      // Inicializar select2
      $selectModulo.select2({
        placeholder: 'Seleccione un modulo',
        allowClear: false,
        dropdownParent: $('#ModalLoading .modal-body')
      }).on('change', () => {

        const selectedId = $selectModulo.val();

        this.loading.production_drying_id = Number($selectModulo.val());

        const selectedModel = this.dryings.find(model => model.id == selectedId);

        if (selectedModel) {
          this.selectedModel = selectedModel;
          console.log('Modelo seleccionado:', selectedModel);
        } else {
          console.log('No se encontró el modelo seleccionado.');
        }
 
      });
    },

    async getLoadings() {

      this.loadings = await this.$store.dispatch("productionLoading/getData", this.form.id);

      const loadingsData = await this.$store.dispatch("productionLoading/getDataOven", this.form.id);

      const $selectUnloadingWarehouse = $(this.$refs.selectUnloadingWarehouse);
      $selectUnloadingWarehouse.empty().append('<option value="">Seleccionar modulo</option>');
      loadingsData.forEach(model => {
        $selectUnloadingWarehouse.append(new Option(model?.model_name + " - Cantidad: " + model?.total_quantity, model.model_id));
      });

      $(this.$refs.selectUnloadingWarehouse).select2({
        placeholder: 'Seleccione un módulo',
        allowClear: false,
        dropdownParent: $('#ModalUnloading .modal-body')
      }).on('change', () => {
        const selectedId = $(this.$refs.selectUnloadingWarehouse).val();

        // buscar modelo por id
        const selectedModel = this.materials.find(model => model.id == selectedId);

        // buscar datos adicionales (puede no existir)
        const selectedData = loadingsData.find(model => model.model_id == selectedId);

        if (selectedModel) {
          // asignar id al objeto unloading
          this.unloading.inventory_id = selectedId;

          // prevenir error si selectedData no existe
          selectedModel.total_quantity = selectedData?.total_quantity ?? 0;

          // actualizar el modelo seleccionado en el componente
          this.selectedModel = selectedModel;

          console.log('Modelo seleccionado:', selectedModel);
        } else {
          console.warn('No se encontró el modelo seleccionado.');
        }
      });


    },
    async getUnloadings() {
      this.unloadings = await this.$store.dispatch("productionUnloading/getData", this.form.id);
    },
    async saveDrying() {
      console.log("Guardar secado");

      if (this.drying.quantity <= 0) {
        await Swal.fire({
          icon: 'error',
          title: 'Error en la cantidad',
          text: 'La cantidad no puede ser cero o negativa',
          confirmButtonText: 'Entendido',
          confirmButtonColor: '#3085d6',
        });
        return; // Detiene la ejecución si la validación falla
      }

      try {
        const response = await this.$store.dispatch("productionDrying/save", this.drying);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then(() => {
            this.drying.id = response?.data?.id || 0;
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        Swal.close();
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async saveLoading() {
      console.log("Guardar cargue");
      try {
        const response = await this.$store.dispatch("productionLoading/save", this.loading);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then(() => {

            this.selectedModel = {};

            this.getDrying();

            this.getLoadings();

            this.closeModalLoading();


          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        Swal.close();
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async saveUnloading() {
      console.log("Guardar descargue",this.unloading);
      try {
        const response = await this.$store.dispatch("productionUnloading/save", this.unloading);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then(() => {
            this.selectedModel = {};
            this.getUnloadings();
            this.getLoadings();
            this.closeModalUnloading();

             this.getMaterials();

             this.getModels();
             this.getBodegas();
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        Swal.close();
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    initCollapses() {
      // Inicializar cada collapse individualmente
      const collapseElements = document.querySelectorAll('.collapse');
      collapseElements.forEach(el => {
        this.collapseInstances[el.id] = new Modal(el, {
          toggle: false
        });
      });
    },
    calcularTiempoEfectivo() {
      this.extrusion.effective_time = Math.max(0, this.extrusion.scheduled_time - this.extrusion.lost_time);
    },
    calcularCantidad() {
      this.extrusion.quantity = this.extrusion.cut_count * this.extrusion.units_per_cut;
    },
    calcularConsumo() {
      this.extrusion.clay_consumption = (this.extrusion.extrusion_quantity * this.extrusion.dry_weight) / 1000;
      this.extrusion.total_consumption = this.extrusion.setup_count > 0
        ? (this.extrusion.clay_consumption * 1000) / this.extrusion.setup_count
        : 0;
    },
    editModal(detail) {
      this.purchase = {
        id: detail.id,
        inventory_id: detail.inventory_id,
        quantity: detail.quantity,
      };

      $('#insumosEdit').val(detail.inventory_id).trigger('change');
      const modalElement = document.getElementById('ModalEditInsumo');
      this.modalEdit = new Modal(modalElement); // Guarda la instancia del modal
      this.modalEdit.show(); // Muestra el modal
    },
    closeEditModal() {
      if (this.modalEdit) {
        this.modalEdit.hide(); // Cierra el modal
      }
    },
    async submitEditForm() {
      try {
        const response = await this.$store.dispatch("productionDetails/save", this.purchase);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then(() => {
            this.getInsumos();
            this.closeEditModal();
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        Swal.close();
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async onBodegaChange(data) {

      await this.$store.dispatch('productionModels/save', data);

      await Swal.fire({
        icon: 'success',
        title: '¡Éxito!',
        text: 'Bodega asignada',
        confirmButtonText: 'Aceptar',
        backdrop: true,
      });

    },
    async handleStatusChange() {
      if (this.form.status === '1') {
        const result = await Swal.fire({
          title: 'Confirmar cambio de estado',
          text: 'Al cambiar a estado activo',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, confirmar',
          cancelButtonText: 'Cancelar',
        });

        if (result.isConfirmed) {
          this.handleStatusChangeSave();
        } else {
          this.form.status = 0;
        }
      } else {
        this.handleStatusChangeSave();
      }

    },
    async handleStatusChangeSave() {
      const response = await this.$store.dispatch("productionOven/save", this.form);
      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire({
          icon: 'success',
          title: '¡Éxito!',
          text: 'El estado cambio correctamente',
          confirmButtonText: 'Aceptar',
          backdrop: true,
        });
      } else {
        await Swal.fire({
          icon: 'error',
          title: '¡Ocurrio un error!',
          text: response.data.message || 'Error al guardar el registro',
          confirmButtonText: 'Aceptar',
          backdrop: true,
        });
      }
    },
    async handleBodegaChange() {
      await this.$store.dispatch("production/save", this.form);
    },
    
    async getNovelties() {
      this.novelties = await this.$store.dispatch('productionNovelty/getData', this.form.id);
    },
    async getOficios() {
      try {
        // Obtener los oficios desde el store
        this.processes = await this.$store.dispatch('users/getOficios');

        // Obtener referencia al select
        const $selectOficio = $(this.$refs.processesSelect);

        // Destruir la instancia previa de Select2 si existe
        if ($selectOficio.data('select2')) {
          $selectOficio.select2('destroy');
        }

        // Limpiar y agregar las opciones dinámicamente
        $selectOficio.empty().append('<option value="">Seleccione un oficio</option>');

        this.processes.forEach(oficio => {

          if(this.production_user.modulo==3){
            if(oficio.id==43 || oficio.id==42 || oficio.id==44 || oficio.id==39){
              $selectOficio.append(new Option(oficio.name, oficio.id));
            }
          }
          
          if(this.production_user.modulo==4){
            if(oficio.id==42 || oficio.id==44 || oficio.id==39 ){
              $selectOficio.append(new Option(oficio.name, oficio.id));
            }
          }
          
        });

        // Inicializar Select2
        $selectOficio.select2({
          placeholder: 'Seleccione un oficio',
          allowClear: true,
        }).on('change', () => {
          this.production_user.oficio_id = $selectOficio.val(); // Usar la variable ya definida
          this.filterUsersByOficio(); // Llamar a la función para filtrar usuarios
        });

        // Si hay un valor pre-seleccionado en production_user.oficio_id
        if (this.production_user.oficio_id) {
          $selectOficio.val(this.production_user.oficio_id).trigger('change');
        }

      } catch (error) {
        console.error('Error al obtener oficios:', error);
      }
    },
    async getCuadrillas() {
      this.cuadrillas = await this.$store.dispatch('crews/getAll');
    },
    async getMaterials() {
      this.materials = await this.$store.dispatch('inventory/getAll');
    },
    async getUsers() {
      this.users = await this.$store.dispatch('users/getAll', 'all');
    },
    filterUsersByOficio() {
      if (this.production_user.oficio_id != 0) {
        this.filteredUsers = this.users.filter(user => {

          const processes = Array.isArray(user.processes) ? user.processes : JSON.parse(user.processes || "[]");

          const matchesOficio = processes.map(Number).includes(Number(this.production_user.oficio_id));

          return matchesOficio;

        });
      } else {
        this.filteredUsers = [];
      }
    },
    isValidDate(date) {
      if (!date) {
        return false;
      }
      const parsedDate = new Date(date);
      return !isNaN(parsedDate.getTime());
    },
    async getModels() {
      this.models = await this.$store.dispatch('inventory/getAll');
    },
    async getSizes() {
      let tallas = await this.$store.dispatch('sizes/getData', this.production_model.model_id);
      this.sizes = tallas.data;
    },
    getIconClass(status) {
      if (status === 0) {
        return 'fa fa-circle'; // Ícono de clic
      } else if (status === 1) {
        return 'fa fa-check-circle text-success'; // Ícono de check verde
      } else if (status === 2) {
        return 'fa fa-times-circle text-danger'; // Ícono de X roja
      }
      return ''; // Devuelve una cadena vacía si no coincide con ningún estado
    },
    editRegisterNovelty(params) {
      this.novelty = params;
      this.openModalNovelty();
    },
    async deleteRegisterNovelty(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionNovelty/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getNovelties();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    openModalNovelty() {
      const modalElement = document.getElementById('ModalNovelty');
      this.modalNovelty = new Modal(modalElement); // Guarda la instancia del modal
      this.modalNovelty.show(); // Muestra el modal
    },
    closeModalNovelty() {
      if (this.modalNovelty) {
        this.modalNovelty.hide(); // Cierra el modal
      }
    },
    async submitFormNovelty() {
      try {
        this.novelty.production_id = this.form.id;
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("productionNovelty/save", this.novelty);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              this.novelty.total = 0;
              this.novelty.observation = '';

              this.closeModalNovelty();
              this.getNovelties();

            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }

    },
    openModal(modulo) {
      this.production_user.modulo = modulo;
      const modalElement = document.getElementById('ModalUsers');
      this.ModalUsers = new Modal(modalElement); // Guarda la instancia del modal
      this.ModalUsers.show(); // Muestra el modal
      this.getOficios();
    },
    closeModal() {
      if (this.ModalUsers) {
        this.ModalUsers.hide(); // Cierra el modal
      }
    },
    openModalDrying() {
      this.calculateTotalQuantity();
      const modalElement = document.getElementById('ModalDrying');
      this.ModalDrying = new Modal(modalElement); // Guarda la instancia del modal
      this.ModalDrying.show(); // Muestra el modal
    },
    closeModalDrying() {
      if (this.ModalDrying) {
        this.ModalDrying.hide(); // Cierra el modal
      }
    },
    openModalLoading() {

      this.getDrying();

      const oven_id = this.loading.production_oven_id;

      const warehouse_id = this.loading.warehouse_id;



      this.loading = {
        id: 0,
        production_oven_id: oven_id,
        production_drying_id: 0,
        quantity: 0,
        burning_number: 0,
        averia_cargue: 0,
        averia_secado: 0,
        total_quantity: 0,
        warehouse_id: warehouse_id
      };



      setTimeout(() => {
        const modalElement = document.getElementById('ModalLoading');
        this.ModalLoading = new Modal(modalElement); // Guarda la instancia del modal
        this.ModalLoading.show(); // Muestra el modal
      }, 0);

    },
    closeModalLoading() {
      if (this.ModalLoading) {
        this.ModalLoading.hide(); // Cierra el modal
      }
    },
    openModalUnloading() {

      const production_id = this.unloading.production_oven_id;
      const warehouse_id = this.unloading.warehouse_id;
      const production_oven_id = this.unloading.production_oven_id;

      this.unloading = {
        id: 0,
        production_oven_id:production_oven_id,
        production_id: production_id,
        inventory_id: 0,
        primera: 0,
        segunda: 0,
        tercera: 0,
        quantity: 0,
        averia_descargue: 0,
        averia_crudo: 0,
        total_quantity: 0,
        warehouse_id: warehouse_id,
        details: [],
        warehouse_primera:'40',
        warehouse_segunda:'40',
        warehouse_tercera:'40',
      }

      const modalElement = document.getElementById('ModalUnloading');
      this.ModalUnloading = new Modal(modalElement); // Guarda la instancia del modal
      this.ModalUnloading.show(); // Muestra el modal
    },
    closeModalUnloading() {
      if (this.ModalUnloading) {
        this.ModalUnloading.hide(); // Cierra el modal
      }
    },


    openModalModel() {
      const modalElement = document.getElementById('ModalModel');
      this.modalModel = new Modal(modalElement); // Guarda la instancia del modal
      this.modalModel.show(); // Muestra el modal
    },
    closeModalModel() {
      if (this.modalModel) {
        this.modalModel.hide(); // Cierra el modal
      }
    },
    openModalDefects() {
      const modalElement = document.getElementById('ModalDefects');
      this.modalDefects = new Modal(modalElement); // Guarda la instancia del modal
      this.modalDefects.show(); // Muestra el modal
    },
    closeModalDefects() {
      if (this.modalDefects) {
        this.modalDefects.hide(); // Cierra el modal
      }
    },
    async getProductionUsers() {
      await this.$store.dispatch('productionUsers/getDataOven', this.form.id, 1);
      this.data = this.$store.state.productionUsers.getData;
    },
    async getInsumos() {
      const data = await this.$store.dispatch('productionModels/getData', this.form.id);
      this.insumos = data.data;
    },
    async getAllInsumos() {
      this.insumosInventory = await this.$store.dispatch('inventory/getAll');
    },
    async save() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("productionOven/save", this.form);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El proyecto ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              this.form.id = response.data.id;

              this.furnaceBurn.production_oven_id = this.form.id || 0;
              this.loading.warehouse_id = this.form.oven_id || 0;
              this.unloading.warehouse_id = this.form.oven_id || 0;
              this.loading.production_oven_id = this.form.id || 0;

              this.unloading.production_oven_id = this.form.id || 0;

              this.production_user.production_oven_id = this.form.id || 0;

            }
          });

        } else {
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        console.error("Error al crear el proyecto:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el proyecto',
        });
      }
    },
    async submitForm() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("productionUsers/save", this.production_user);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.getProductionUsers();
              this.closeModal();

              this.production_user.production_models_id = 0;
              this.production_user.oficio_id = 0;
              this.production_user.user_id = [];
              this.production_user.received_quantity = 0;
              this.production_user.price = 0;
              this.production_user.delivered_quantity = 0;


              $(this.$refs.modelUserSelect).val(null).trigger('change');
              $(this.$refs.processesSelect).val(null).trigger('change');
              $(this.$refs.usersSelect).val(null).trigger('change');

            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }

    },
    async submitFormModel() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("productionModels/save", this.production_model);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              this.production_model.model_id = 0;
              this.production_model.size_id = 0;
              this.production_model.quantity_to_produce = 0;
              this.production_model.price = 0;

              $(this.$refs.modelSelect).val(null).trigger('change');
              $(this.$refs.sizesSelect).val(null).trigger('change');


              this.getInsumos();
              this.closeModalModel();


            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }

    },
    async deleteRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionModels/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getInsumos();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    viewObservation(observation) {
      // Mostramos el mensaje en un SweetAlert
      Swal.fire({
        title: 'Observación',
        text: observation || 'No hay observaciones disponibles.',
        icon: 'info',  // Puedes cambiar el icono a info, success, warning, etc.
        confirmButtonText: 'Aceptar'
      });
    },
    async checkReceived(value) {

      try {
        const result = await Swal.fire({
          title: 'Iniciar trabajo',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, aceptar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {

          const now = new Date();
          const pad = n => String(n).padStart(2, '0');

          value.received_date = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;

          const response = await this.$store.dispatch("productionUsers/save", value);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Trabajo iniciado!',
              'Recuerda finalizar la jornada.',
              'success'
            );

            this.getProductionUsers();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },

    async checkDelivered(value) {

      try {
        const result = await Swal.fire({
          title: 'Finalizar trabajo',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, aceptar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {

          const now = new Date();
          const pad = n => String(n).padStart(2, '0');

          value.delivered_date = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;

          const response = await this.$store.dispatch("productionUsers/save", value);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Trabajo finalizado!',
              'El registro se ha guardado correctamente.',
              'success'
            );

            this.getProductionUsers();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },

    async checkValidated(value) {

      try {

        const { value: formValues } = await Swal.fire({
          title: 'Validar jornada',
          html: `
          <div style="text-align: left;">
              <div class="mb-3">
                <label for="swal-input-cant" class="form-label" style="font-weight: bold;">Validar jornada del trabajador</label>
              </div>
              <div class="mb-3">
                <label for="swal-input-obs" class="form-label" style="font-weight: bold;">Observación:</label>
                <textarea id="swal-input-obs" class="form-control" placeholder="Agregue una observación" rows="3"></textarea>
              </div>
            </div>`,
          focusConfirm: false,
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, aceptar!',
          cancelButtonText: 'Cancelar',
          preConfirm: () => {
            return {
              obs: document.getElementById('swal-input-obs').value
            };
          }
        });

        if (formValues) {

          const now = new Date();
          const pad = n => String(n).padStart(2, '0');

          value.validated_date = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;

          value.observation = formValues.obs;
          value.finish = 1;

          const response = await this.$store.dispatch("productionUsers/save", value);

          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire(
              'Jordada validada!',
              'Excelente trabajo.',
              'success'
            );
            this.getProductionUsers();
          } else {
            this.getProductionUsers();
            throw new Error(response.data.message || 'Error al guardar el registro');
          }
        }
      } catch (error) {
        console.error("Error al guardar el registro:", error);


        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });



      }
    },
    async checkValidatedOld(value) {
      try {
        const { value: cant } = await Swal.fire({
          title: 'Validar Tarea',
          html: `
        <div style="text-align: left;">
          <div class="mb-3">
            <label for="swal-input-defect" class="form-label" style="font-weight: bold;">Cantidad con defectos:</label>
            <input id="swal-input-defect" type="number" class="form-control" placeholder="Cantidad con defectos" min="0">
          </div>
        </div>
      `,
          focusConfirm: false,
          preConfirm: () => {
            const defectInput = document.getElementById('swal-input-defect').value;
            const defectValue = Number(defectInput); // Convertir a número

            if (isNaN(defectValue) || defectValue < 0) {
              Swal.showValidationMessage('Debe ingresar una cantidad válida.');
              return false;
            }

            if (defectValue > Number(value.received_quantity)) {
              Swal.showValidationMessage('La cantidad supera la asignada.');
              return false;
            }

            return defectValue; // Retorna el valor válido
          },
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
        });

        if (cant !== undefined) {
          value.validated_date = new Date().toISOString().slice(0, 10);
          value.rejected_quantity = cant;
          value.finish = 1;

          const response = await this.$store.dispatch("productionUsers/save", value);
          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire('Tarea Validada!', 'Excelente trabajo.', 'success');
            this.getProductionUsers();
            this.getInsumos();
          } else {
            throw new Error(response.data.message || 'Error al guardar el registro');
          }
        }
      } catch (error) {
        console.error("Error al guardar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    }
    ,
    async deleteUserRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionUsers/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getProductionUsers();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },

  },
  async mounted() {

    $(".select-tags").select2({
        tags: true,
        tokenSeparators: [',', ' ']
    })

    $(this.$refs.cuadrillaSelect).select2({
      placeholder: 'Seleccione una cuadrilla',
      allowClear: true,
    }).on('change', () => {
      this.production_user.cuadrilla = $(this.$refs.cuadrillaSelect).val();
    });

    const today = new Date();
    this.form.started_at = today.toISOString().slice(0, 10);

    // Sumar 5 días
    const estimatedDate = new Date(today);
    estimatedDate.setDate(today.getDate() + 5);
    this.form.estimated_at = estimatedDate.toISOString().slice(0, 10);


    for (let i = 0; i < 4; i++) {
      const ref = this.$refs[`collapse${i}`]
      if (ref) {
        this.bsCollapse[i] = new Collapse(ref, { toggle: false })
      }
    }

   
    this.getDrying();
    this.getOficios();
    this.getCuadrillas();
    this.getUsers();
    this.getMaterials();

    await this.getModels();
    await this.getBodegas();

    this.$nextTick(() => {

       const dataEdit = this.route.params.data;

      // Agregar las opciones dinámicamente
      const $select = $(this.$refs.modelSelect);
      $select.empty().append('<option value="">Seleccionar horno</option>');
      this.bodegas.filter(h => h.tipo === 2).forEach(model => {

        if(!dataEdit && model.status==1){ return;}
        $select.append(new Option(model.name, model.id));
      });
      $(this.$refs.modelSelect).select2({
        placeholder: 'Seleccione un horno',
        allowClear: false,
      }).on('change', () => {
        this.form.oven_id = $(this.$refs.modelSelect).val();
      });

      $(this.$refs.processesSelect).select2({
        placeholder: 'Seleccione un oficio',
        allowClear: true,
      }).on('change', () => {
        this.production_user.oficio_id = $(this.$refs.processesSelect).val();
        this.filterUsersByOficio();
      });
      $(this.$refs.processesSelect).val(null).trigger('change');

     

      try {
        // Si hay datos para editar, cargarlos
        if (dataEdit) {
          const params = JSON.parse(dataEdit);
          this.data = params;
          if (params && params.id) {

            //Formulario principal
            this.form.id = params.id || 0;
            this.form.consecutive = String(params.consecutive) || '';
            this.form.consecutivo_secado = String(params.consecutivo_secado) || '';
            this.form.user_id = params.user_id || '';
            this.form.oven_id = params.oven_id || '';
            this.form.burn_number = params.burn_number || '';
            this.form.started_at = params.started_at || '';
            this.form.estimated_at = params.estimated_at || '';
            this.form.finished_at = params.finished_at || '';
            this.form.finished_user_id = params.finished_user_id || '';
            this.form.status = params.status || '';

            this.furnaceBurn.production_oven_id = params.id || 0;

            $(this.$refs.modelSelect).val(this.form.oven_id).trigger('change');

            this.getProductionUsers();

            this.getLoadings();

            this.getUnloadings();

            this.getFurnace();

            this.production_user.production_oven_id = params.id || null;

            this.furnaceBurn.oven_id = params.id || 0;

            this.loading.warehouse_id = params.oven_id || 0;
            this.loading.production_oven_id = params.id || '';

            this.unloading.warehouse_id = params.oven_id || 0;
            this.unloading.production_oven_id = params.id || 0;
            

          }

        }

        // Cerrar el modal de carga
        Swal.close();
      } catch (error) {
        // Manejo de errores
        console.error("Error al cargar los datos:", error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Hubo un problema al cargar los datos. Por favor, inténtalo nuevamente.',
        });
      }

    });

    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {

    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style>
.disabled-link {
  color: gray;
  pointer-events: none;
  /* Impide la interacción */
  cursor: not-allowed;
  /* Cambia el cursor para indicar que está deshabilitado */
}
</style>
